export default __webpack_public_path__ + "static/media/1955.94454f8a.png";